import { Card, CardContent, Box, Typography, Grid } from "@mui/material";
import { Phone as PhoneIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { isFieldDiff } from "../../../../../types/review";
import FieldDiff from "./FieldDiff";

interface ContactPersonDetailsProps {
  contact: {
    fullName?: string | { old: string; new: string };
    country_code?: string | { old: string; new: string };
    phone?: string | { old: string; new: string };
  };
}

const ContactPersonDetails = ({ contact }: ContactPersonDetailsProps) => {
  const { t } = useTranslation();
  return (
    <Grid size={12}>
      <Card variant="outlined">
        <CardContent>
          <Box display="flex" alignItems="center" mb={2}>
            <PhoneIcon sx={{ mr: 1 }} />
            <Typography variant="h6">{t("carWashDetails.contactPerson")}</Typography>
          </Box>
          <Grid container spacing={2}>
            {contact.fullName && (
              <Grid size={12}>
                <Typography variant="body2" color="text.secondary">
                  {t("carWashDetails.fullName")}
                </Typography>
                {isFieldDiff(contact.fullName) ? (
                  <FieldDiff diff={contact.fullName} />
                ) : (
                  <Typography variant="body1">{contact.fullName}</Typography>
                )}
              </Grid>
            )}
            {contact.country_code && (
              <Grid size={6}>
                <Typography variant="body2" color="text.secondary">
                  {t("carWashDetails.countryCode")}
                </Typography>
                {isFieldDiff(contact.country_code) ? (
                  <FieldDiff diff={contact.country_code} />
                ) : (
                  <Typography variant="body1">{contact.country_code}</Typography>
                )}
              </Grid>
            )}
            {contact.phone && (
              <Grid size={6}>
                <Typography variant="body2" color="text.secondary">
                  {t("carWashDetails.phone")}
                </Typography>
                {isFieldDiff(contact.phone) ? (
                  <FieldDiff diff={contact.phone} />
                ) : (
                  <Typography variant="body1">{contact.phone}</Typography>
                )}
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default ContactPersonDetails;
